// extracted by mini-css-extract-plugin
module.exports = {"section":"_3suD2","textImageItemRoot":"H1twn","textImageItemWrapper":"_2xBbN"};